/***
 *
 *   ACCOUNT
 *   Index page for account functions
 *
 **********/

import { Animate, Icon, Link, Loader, useAPI } from "components/lib";
import { useEffect } from "react";

export function Account(props) {
  const user = useAPI("/api/user");
  const iconSize = 20;

  useEffect(() => {
    console.log(user);
  }, [user]);

  if (user.loading) return <Loader />;

  return (
    <Animate>
      <div style={{ display: "flex" }}>
        <div
          style={{
            background: "white",
            padding: 25,
            borderRadius: 5,
            marginRight: 20,
            width: 400,
            height: 180,
          }}
        >
          <Icon image="user" size={iconSize} />
          <h2 className={Style.subtitle}>Profile</h2>
          <div>Update your profile information</div>
          <Link url="/app/account/profile" className={Style.link}>
            Update
          </Link>
        </div>

        {user.data && user.data.permission === "owner" && (
          <div
            style={{
              background: "white",
              padding: 25,
              borderRadius: 5,
              marginRight: 20,
              width: 400,
              height: 180,
            }}
          >
            <Icon image="lock" size={iconSize} />
            <h2 className={Style.subtitle}>Signature</h2>
            <div>Update your signature</div>
            <Link url="/app/account/signature" className={Style.link}>
              Update
            </Link>
          </div>
        )}

        <div
          style={{
            background: "white",
            padding: 25,
            borderRadius: 5,
            marginRight: 20,
            width: 400,
            height: 180,
          }}
        >
          <Icon image="lock" size={iconSize} />
          <h2 className={Style.subtitle}>Password</h2>
          <div>
            {user?.data?.["has_password"]
              ? "Change your password"
              : "Create a password"}
          </div>
          <Link url="/app/account/password" className={Style.link}>
            {user?.data?.["has_password"] ? "Change" : "Create"}
          </Link>
        </div>

        {user.data && user.data.permission === "owner" && (
          <div
            style={{
              background: "white",
              padding: 25,
              borderRadius: 5,
              marginRight: 20,
              width: 400,
              height: 180,
            }}
          >
            <Icon image="lock" size={iconSize} />
            <h2 className={Style.subtitle}>Company</h2>
            <div>Update company details</div>
            <Link url="/app/account/company" className={Style.link}>
              Update
            </Link>
          </div>
        )}

        {user.data && user.data.permission === "owner" && (
          <div
            style={{
              background: "white",
              padding: 25,
              borderRadius: 5,
              marginRight: 20,
              width: 400,
              height: 180,
            }}
          >
            <Icon image="lock" size={iconSize} />
            <h2 className={Style.subtitle}>Commissions</h2>
            <div>See commissions documents</div>
            <Link url="/app/account/commissions" className={Style.link}>
              View
            </Link>
          </div>
        )}

        {user.data && user.data.permission === "owner" && (
          <div
            style={{
              background: "white",
              padding: 25,
              borderRadius: 5,
              marginRight: 20,
              width: 400,
              height: 180,
            }}
          >
            <Icon image="lock" size={iconSize} />
            <h2 className={Style.subtitle}>Users</h2>
            <div>View and add users to your agency</div>
            <Link url="/app/account/users" className={Style.link}>
              View
            </Link>
          </div>
        )}
      </div>
    </Animate>
  );
}

const Style = {
  subtitle: "font-bold mt-4",
  link: "text-red-600 font-semibold mt-3 inline-block",
};
